import { IUseFetchOptionsParams } from '@common/api.models';
import { FETCH_QUERIES_NAME } from '@common/constants';
import { createUseFetchOptionsNoPropsFn } from '@common/selectOptions.services';
import { getAllVoItemsAsync } from './voItem.services';

export const useFetchAllVoItems = ({ isDirty = false, shouldConvertOptions = false }: IUseFetchOptionsParams) =>
  createUseFetchOptionsNoPropsFn({
    queryName: FETCH_QUERIES_NAME.VO_ITEM,
    getOptionsFn: getAllVoItemsAsync,
    handleOptionsProps: {
      shouldConvertOptions,
      textFieldName: 'name',
    },
    enabled: !isDirty,
  });
